module.exports = __webpack_public_path__ + "static/media/global_payments.c3cffc5d.png";